export default function Insurance() {
  return (
    <section className="py-12 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-[#111317] mb-3">
            Aseguradoras Médicas
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Trabajamos con las principales aseguradoras médicas de México para facilitar tu atención
          </p>
        </div>

        {/* Imagen única centrada */}
        <div className="w-full flex items-center justify-center">
          <img
            src="https://blog.coisalud.com/hs-fs/hubfs/aseguradoras-que-cubren-a-pacientes-con-cancer.png?width=1024&height=489&name=aseguradoras-que-cubren-a-pacientes-con-cancer.png"
            alt="Aseguradoras médicas que cubren a pacientes con cáncer"
            className="max-w-full h-auto rounded-xl shadow-md"
            loading="lazy"
          />
        </div>

        <div className="text-center mt-8">
          <p className="text-sm text-gray-600" data-component-name="Insurance">
            Si no aparece tu aseguradora, nos adecuamos al seguro existente que tengas.
          </p>
        </div>
      </div>

      {/* Estilos del carrusel eliminados por no ser necesarios */}
    </section>
  );
}
